jQuery(document).ready(function ($) {

    function moveIndicator(element, image) {
        var position = $('.info-point[data-id="' + element + '"]').position();
        var containerWidth = $('.info-points').innerWidth();
        var remainingWidth = (image.innerWidth() - containerWidth) / 2;
        var top = position.top + 24;
        var left = position.left + 24 + remainingWidth;

        image.css({
            'transform': 'scale(2.3)',
            'transform-origin': left + 'px' + ' ' + top + 'px'
        });

        image.addClass('zoomed');
    }

    function scaleToPoint(element) {
        var houseImage = $('.virtual-house__canvas');

        // Reset
        houseImage.css({
            'transform': 'scale(1)',
            'transform-origin': 'none'
        });

        houseImage.removeClass('zoomed');

        if (houseImage.hasClass('moved')) {
            setTimeout(function () {
                moveIndicator(element, houseImage);
            }, 400);

            return;
        }

        moveIndicator(element, houseImage);
        houseImage.addClass('moved');
    }

    $('.virtual-house__list li').on('click', function (e) {
        var id = $(this).data("id");
        $('.virtual-house__info-box').removeClass('active');
        $('.virtual-house__list li').removeClass('active');
        $('.info-point').removeClass('active');
        $('.info-point[data-id="' + id + '"]').addClass('active');
        $(id).addClass('active');
        $(this).addClass('active');
        scaleToPoint($(this).data("id"));
    });

    $('.info-point').on('click', function () {
        var id = $(this).data("id");
        $('.virtual-house__info-box').removeClass('active');
        $('.virtual-house__list li').removeClass('active');
        $('.info-point').removeClass('active');
        $('.virtual-house__list li[data-id="' + id + '"]').addClass('active');
        $(id).addClass('active');
        $(this).addClass('active');
        scaleToPoint($(this).data("id"));
    });

    var houseImage = $('.virtual-house__canvas');

    houseImage.on('click', function () {

        // Reset
        houseImage.css({
            'transform': 'scale(1)',
            'transform-origin': 'none'
        });

        $('.virtual-house__info-box').removeClass('active');
        $('.virtual-house__list li').removeClass('active');
        $('.info-point').removeClass('active');
        $('.virtual-house__info-box--basic').addClass('active');
        houseImage.removeClass('zoomed');
        houseImage.removeClass('moved');
    });

    // Prevent events from getting pass .virtual-house__canvas
    $(".info-point, .virtual-house__list, .virtual-house__info-box").on('click', function (e) {
        e.stopPropagation();
    });
});
